// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as RnrHeader from "./RnrHeader.bs.js";
import * as RnrDashboard from "./RnrDashboard.bs.js";
import * as RnrRepoManager from "../domain/repo/RnrRepoManager.bs.js";
import * as RnrAssetManager from "../assets/RnrAssetManager.bs.js";
import * as RnrParamsProvider from "../utils/version/RnrParamsProvider.bs.js";
import * as RnrCycleEndErrorCmp from "./RnrCycleEndErrorCmp.bs.js";
import * as RnrCustomLoaderComponent from "./RnrCustomLoaderComponent.bs.js";

RnrAssetManager.importCss(undefined);

var tapToRetry = RnrAssetManager.getImage("tapToRetry.svg");

var RnrLoaderConfig = {};

var RnrLoaderComponent = RnrCustomLoaderComponent.LoaderComponent(RnrLoaderConfig);

function RnrDashboardWrapper(Props) {
  var uuid = Props.uuid;
  var authToken = Props.authToken;
  var language = Props.language;
  var version = Props.version;
  var version_code = Props.version_code;
  return React.createElement(RnrParamsProvider.make, RnrParamsProvider.makeProps({
                  version: version,
                  uuid: uuid,
                  lang: language,
                  auth_token: authToken,
                  version_code: version_code
                }, React.createElement(RnrLoaderComponent.make, {
                      fetchData: (function (param) {
                          var RepoInstance = RnrRepoManager.getRnrRepo(undefined);
                          return Curry._3(RepoInstance.fetchRnrReport, uuid, authToken, language);
                        }),
                      renderView: (function (rnrReport, refreshView) {
                          return React.createElement("div", {
                                      className: "rnr-dashboard-base"
                                    }, React.createElement(RnrHeader.make, {}), React.createElement(RnrDashboard.RnrDashboard.make, {
                                          rnrReport: rnrReport,
                                          refreshView: refreshView
                                        }));
                        }),
                      custom_error_cmp: React.createElement(React.Fragment, undefined, React.createElement(RnrHeader.make, {}), React.createElement(RnrCycleEndErrorCmp.make, {
                                uuid: uuid,
                                auth_token: authToken,
                                language: language
                              }))
                    }), undefined));
}

var make = RnrDashboardWrapper;

var $$default = RnrDashboardWrapper;

export {
  tapToRetry ,
  RnrLoaderConfig ,
  RnrLoaderComponent ,
  make ,
  $$default ,
  $$default as default,
  
}
/*  Not a pure module */
